export default __webpack_public_path__ + "static/media/circles-no-5.b54c0b1d.mid";